import { useState } from "react";

/**

 *
 * @returns {{
 *   emailModalOpen: boolean,
 *   selectedJob: { id: number, name: string } | null,
 *   handleViewEmail: (row: object) => void,
 *   closeEmailModal: () => void,
 * }}
 */
export function useEmailDetailModal() {
    const [emailModalOpen, setEmailModalOpen] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [selectedReportData, setSelectedReportData] = useState(null);
    const [selectedReportId, setSelectedReportId] = useState(null);

    const handleViewEmail = (row) => {
        setSelectedJob({ id: row.jobId ?? row.id, name: row.jobName ?? row.name });

        const reportIdFromRow = row?.reportId ?? undefined;
        const looksLikeReportRow = Boolean(row?.lastEmail || row?.checkedAt);
        const looksLikeJobRow = Boolean(row?.status || row?.statusCheckedAt);

        // Cas 1: ligne de SauvegardesPage = job + éventuellement reportId
        if (reportIdFromRow !== undefined) {
            const reportId = reportIdFromRow !== null ? Number(reportIdFromRow) : null;
            setSelectedReportId(reportId);

            if (reportId === null) {
                // Aucun report "aujourd'hui" : on passe un placeholder pour éviter de tomber
                // sur le "latest by job" (souvent hier).
                setSelectedReportData({
                    id: null,
                    statusType: { name: row?.status || "UNKNOWN" },
                    summary: row?.statusSummary || null,
                    checkedAt: row?.statusCheckedAt || null,
                    lastEmail: null,
                });
            } else {
                // Si on a un reportId, EmailDetailModal le chargera pour afficher les emails.
                setSelectedReportData(null);
            }
        } else if (looksLikeReportRow) {
            // Cas 2: ligne de ReportsPage = reportStatus
            setSelectedReportId(Number(row.id));
            // On conserve le contexte même si lastEmail est null.
            setSelectedReportData(row);
        } else if (looksLikeJobRow) {
            // Cas 3: ligne de SauvegardesPage = job
            setSelectedReportId(null);
            setSelectedReportData({
                id: null,
                statusType: { name: row?.status || "UNKNOWN" },
                summary: row?.statusSummary || null,
                checkedAt: row?.statusCheckedAt || null,
                lastEmail: null,
            });
        } else {
            // Cas fallback (normalement rare)
            setSelectedReportId(null);
            setSelectedReportData(null);
        }

        setEmailModalOpen(true);
    };

    const closeEmailModal = () => {
        setEmailModalOpen(false);
        setSelectedReportData(null);
        setSelectedReportId(null);
    };

    return { emailModalOpen, selectedJob, selectedReportData, selectedReportId, handleViewEmail, closeEmailModal };
}
